import { Label } from '@givebutter/primitives/label';
import * as Form from 'components/form';
import * as Input from 'components/input';
import * as SettingsCard from 'components/settings-card';
import { CAMPAIGN_LIVE_DISPLAY_LINK } from 'constants/links';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';

const CampaignSharingLiveDisplay = () => {
    const { data: campaign } = useCurrentCampaign();
    const liveDisplayUrl = campaign?.live_display_url;

    return (
        <SettingsCard.Root>
            <SettingsCard.LeftSide>
                <SettingsCard.Heading>Live Display</SettingsCard.Heading>
                <p className={'text-sm text-gray-700'}>
                    Live Display allows anyone hosting an in-person event to showcase campaign
                    activity in real-time on a TV, projector screen, or tablet.{' '}
                    <a target="_blank" rel="noopener noreferrer" href={CAMPAIGN_LIVE_DISPLAY_LINK}>
                        Read the guide
                    </a>
                    .
                </p>
            </SettingsCard.LeftSide>
            <SettingsCard.RightSide>
                <Form.Container>
                    <Label className={'text-base'}>Live Display link</Label>
                    <Input.Root>
                        <Input.Form readOnly={true} value={liveDisplayUrl} />
                        {liveDisplayUrl && <Input.CopyButton text={liveDisplayUrl} />}
                    </Input.Root>
                    <p className={'text-sm text-gray-700'}>
                        Find your Live Display here:&nbsp;
                        <a href={liveDisplayUrl} target="_blank" rel="noreferrer">
                            {liveDisplayUrl}
                        </a>
                    </p>
                </Form.Container>
            </SettingsCard.RightSide>
        </SettingsCard.Root>
    );
};

export { CampaignSharingLiveDisplay };
